import { useEffect, useState } from 'react';
import { collection, onSnapshot, doc, updateDoc, serverTimestamp, getDocs, query, where, getDoc, addDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { Link } from 'react-router-dom';

export default function Results() {
  const [matches, setMatches] = useState([]);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [resultList, setResultList] = useState([{ rank: '1st', gameId: '', prize: '' }]);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'matches'), (snap) => {
      const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      data.sort((a, b) => (b.createdAt?.seconds ?? 0) - (a.createdAt?.seconds ?? 0));
      setMatches(data);
    });
    return () => unsub();
  }, []);

  const selectMatch = async (match) => {
    setSelectedMatch(match);
    setSaved(false);

    // আগের result থাকলে load করো
    if (match.resultList?.length) {
      setResultList(match.resultList);
      return;
    }

    // Bookings থেকে participants fetch করো
    try {
      const bookingSnap = await getDocs(
        query(collection(db, 'bookings'), where('matchId', '==', match.id))
      );

      if (bookingSnap.empty) {
        setResultList([{ rank: '', gameId: '', prize: '' }]);
        return;
      }

      const rows = [];
      bookingSnap.docs.forEach((d, i) => {
        const data = d.data();
        // Solo
        rows.push({ rank: '', gameId: data.gameName ?? '', prize: '' });
        // Duo/Squad এর partner রাও add করো
        if (data.gameName2) rows.push({ rank: '', gameId: data.gameName2, prize: '' });
        if (data.gameName3) rows.push({ rank: '', gameId: data.gameName3, prize: '' });
        if (data.gameName4) rows.push({ rank: '', gameId: data.gameName4, prize: '' });
      });

      setResultList(rows);
    } catch (e) {
      setResultList([{ rank: '', gameId: '', prize: '' }]);
    }
  };

  const updateRow = (i, field, value) => {
    const updated = [...resultList];
    updated[i] = { ...updated[i], [field]: value };
    setResultList(updated);
  };

  const addRow = () => {
    setResultList([...resultList, { rank: '', gameId: '', prize: '' }]);
  };

  const removeRow = (i) => {
    setResultList(resultList.filter((_, idx) => idx !== i));
  };

  const handleSave = async () => {
  if (!selectedMatch) return;
  setSaving(true);
  try {
    // Result save করো
    await updateDoc(doc(db, 'matches', selectedMatch.id), {
      resultList,
      status: 'finished',
      resultUpdatedAt: serverTimestamp(),
    });

    // প্রতিটা winner এর wallet এ prize add করো
    for (const row of resultList) {
      if (!row.gameId || !row.prize) continue;

      const bookingSnap = await getDocs(
        query(
          collection(db, 'bookings'),
          where('matchId', '==', selectedMatch.id),
          where('gameName', '==', row.gameId.trim())
        )
      );

      if (bookingSnap.empty) continue;

const bookingDoc = bookingSnap.docs[0];
const booking = bookingDoc.data();
const userId = booking.userId;

// Already prize পেয়েছে কিনা check করো
if (booking.prizePaid === true) continue;

      if (!userId) continue;

      const prizeAmount = Number(row.prize);
      if (!prizeAmount) continue;

      const userSnap = await getDoc(doc(db, 'users', userId));
      if (!userSnap.exists()) continue;

      const currentBalance = userSnap.data()?.balance ?? 0;

      await updateDoc(doc(db, 'users', userId), {
        balance: currentBalance + prizeAmount,
      });
      await updateDoc(doc(db, 'bookings', bookingDoc.id), {
      prizePaid: true,
      });

      await addDoc(collection(db, 'walletHistory'), {
        userId,
        type: 'prize',
        amount: prizeAmount,
        matchId: selectedMatch.id,
        matchTitle: selectedMatch.title,
        rank: row.rank,
        gameName: row.gameId,
        status: 'completed',
        createdAt: serverTimestamp(),
      });
    }

    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  } catch (e) {
    alert('Error: ' + e.message);
  }
  setSaving(false);
};

  const sidebarLinks = [
   { to: '/', label: '🏠 Dashboard' },
    { to: '/matches', label: '🎯 Matches', },
    { to: '/results', label: '🏆 Results', active: true },
    { to: '/users', label: '👥 Users' },
    { to: '/deposits', label: '💰 Deposits' },
    { to: '/withdrawals', label: '⬆️ Withdrawals' },
    { to: '/settings', label: '⚙️ Settings' },
    { to: '/password-resets', label: '🔑 Password Resets' },
    { to: '/videos', label: '🎬 Videos' }
  ];

  return (
    <div style={styles.container}>

      {/* Sidebar */}
      <div style={styles.sidebar}>
        <div style={styles.sidebarLogo}>🎮 FF Arena</div>
        <div style={styles.sidebarSub}>Admin Panel</div>
        <nav style={styles.nav}>
          {sidebarLinks.map(l => (
            <Link key={l.to} to={l.to} style={l.active ? styles.navItemActive : styles.navItem}>
              {l.label}
            </Link>
          ))}
        </nav>
      </div>

      {/* Main */}
      <div style={styles.main}>
        <h1 style={styles.pageTitle}>🏆 Results</h1>
        <p style={styles.pageSub}>Match শেষে result add করো — user এর My Slots এ দেখাবে</p>

        <div style={styles.layout}>

          {/* Left: Match List */}
          <div style={styles.matchList}>
            <div style={styles.cardTitle}>📋 Match List</div>
            {matches.length === 0 && (
              <div style={{ color: '#555', padding: 20, textAlign: 'center' }}>কোনো match নেই</div>
            )}
            {matches.map(m => (
              <div
                key={m.id}
                style={{
                  ...styles.matchCard,
                  borderColor: selectedMatch?.id === m.id ? '#f4c430' : '#1e1e3a',
                  background: selectedMatch?.id === m.id ? '#f4c43011' : '#0d0d20',
                }}
                onClick={() => selectMatch(m)}
              >
                <div style={styles.matchCardTop}>
                  <span style={styles.matchCardTitle}>
                   <span style={{ color: '#f4c430', marginRight: 6 }}>#{m.matchNumber ?? '—'}</span>
                    {m.title}
                      </span>
                  <span style={{
                    ...styles.statusBadge,
                    background: m.status === 'finished' ? '#16a34a22' : m.status === 'open' ? '#00c89622' : '#ff444422',
                    color: m.status === 'finished' ? '#16a34a' : m.status === 'open' ? '#00c896' : '#ff4444',
                  }}>{m.status}</span>
                </div>
                <div style={styles.matchCardId}>ID: {m.id}</div>
                <div style={styles.matchCardMeta}>{m.mode} • {m.matchTime}</div>
              </div>
            ))}
          </div>

          {/* Right: Result Form */}
          <div style={styles.resultForm}>
            {!selectedMatch ? (
              <div style={styles.emptyState}>
                <div style={{ fontSize: 48, marginBottom: 12 }}>👈</div>
                <div style={{ color: '#555', fontSize: 14 }}>বাম থেকে একটা match select করো</div>
              </div>
            ) : (
              <>
                {/* Selected Match Info */}
                <div style={styles.selectedCard}>
                  <div style={styles.cardTitle}>✅ Selected Match</div>
                  <div style={styles.selectedTitle}>{selectedMatch.title}</div>
                  <div style={styles.selectedMeta}>
                    <span style={styles.idBadge}>ID: {selectedMatch.id}</span>
                    <span style={styles.modeBadge}>{selectedMatch.mode}</span>
                    <span style={styles.timeBadge}>🕐 {selectedMatch.matchTime}</span>
                  </div>
                </div>

                {/* Result Table */}
                <div style={styles.resultCard}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <div style={styles.cardTitle}>🏅 Result Entry</div>
                    <button style={styles.addRowBtn} onClick={addRow}>+ Add Row</button>
                  </div>

                  {/* Header Row */}
                  <div style={styles.tableHeader}>
                    <div style={{ width: 80 }}>Rank</div>
                    <div style={{ flex: 1 }}>Game ID / Player Name</div>
                    <div style={{ width: 120 }}>Prize (৳)</div>
                    <div style={{ width: 40 }}></div>
                  </div>

                  {resultList.map((row, i) => (
                    <div key={i} style={styles.tableRow}>
                      <input
                        style={{ ...styles.input, width: 80 }}
                        value={row.rank}
                        onChange={e => updateRow(i, 'rank', e.target.value)}
                        placeholder="1st"
                      />
                      <input
                        style={{ ...styles.input, flex: 1 }}
                        value={row.gameId}
                        onChange={e => updateRow(i, 'gameId', e.target.value)}
                        placeholder="Game ID / Player Name"
                      />
                      <input
                        style={{ ...styles.input, width: 120 }}
                        value={row.prize}
                        onChange={e => updateRow(i, 'prize', e.target.value)}
                        placeholder="500"
                      />
                      <button style={styles.removeBtn} onClick={() => removeRow(i)}>✕</button>
                    </div>
                  ))}

                  <button
                    style={{ ...styles.saveBtn, opacity: saving ? 0.6 : 1, marginTop: 20 }}
                    onClick={handleSave}
                    disabled={saving}
                  >
                    {saving ? '⏳ Save হচ্ছে...' : '💾 Result Save করো (Status → Finished)'}
                  </button>

                  {saved && (
                    <div style={styles.successMsg}>
                      ✅ Result save হয়েছে! Match status "finished" হয়ে গেছে। User এর My Slots এ দেখাবে।
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', minHeight: '100vh', background: '#0a0a1a' },
  sidebar: {
    width: 240, background: '#111128', borderRight: '1px solid #1e1e3a',
    padding: '24px 0', display: 'flex', flexDirection: 'column',
    position: 'fixed', height: '100vh',
  },
  sidebarLogo: { color: '#f4c430', fontSize: 20, fontWeight: 'bold', padding: '0 24px', marginBottom: 4 },
  sidebarSub: { color: '#555', fontSize: 12, padding: '0 24px', marginBottom: 32 },
  nav: { display: 'flex', flexDirection: 'column', flex: 1 },
  navItem: { color: '#888', textDecoration: 'none', padding: '12px 24px', fontSize: 14, fontWeight: '500', borderLeft: '3px solid transparent' },
  navItemActive: { color: '#f4c430', textDecoration: 'none', padding: '12px 24px', fontSize: 14, fontWeight: '600', borderLeft: '3px solid #f4c430', background: '#f4c43011' },
  main: { marginLeft: 240, flex: 1, padding: 32 },
  pageTitle: { color: '#fff', fontSize: 28, fontWeight: 'bold', margin: 0 },
  pageSub: { color: '#666', fontSize: 14, marginTop: 6, marginBottom: 24 },
  layout: { display: 'flex', gap: 24, alignItems: 'flex-start' },
  matchList: {
    width: 300, background: '#111128', borderRadius: 16,
    border: '1px solid #1e1e3a', padding: 20, flexShrink: 0,
    maxHeight: '80vh', overflowY: 'auto',
  },
  cardTitle: { color: '#fff', fontSize: 15, fontWeight: 'bold', marginBottom: 16 },
  matchCard: {
    borderRadius: 12, border: '1px solid', padding: 14,
    marginBottom: 10, cursor: 'pointer', transition: 'all 0.15s',
  },
  matchCardTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 },
  matchCardTitle: { color: '#fff', fontSize: 13, fontWeight: '600', flex: 1, marginRight: 8 },
  matchCardId: { color: '#444', fontSize: 10, marginBottom: 4, fontFamily: 'monospace' },
  matchCardMeta: { color: '#666', fontSize: 11 },
  statusBadge: { fontSize: 10, fontWeight: 'bold', padding: '3px 8px', borderRadius: 6, flexShrink: 0 },
  resultForm: { flex: 1 },
  emptyState: {
    background: '#111128', borderRadius: 16,
    border: '1px solid #1e1e3a', padding: 60,
    textAlign: 'center',
  },
  selectedCard: {
    background: '#111128', borderRadius: 16,
    border: '1px solid #f4c43033', padding: 20, marginBottom: 20,
  },
  selectedTitle: { color: '#fff', fontSize: 18, fontWeight: 'bold', marginBottom: 10 },
  selectedMeta: { display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' },
  idBadge: { background: '#1e1e3a', color: '#888', fontSize: 11, padding: '4px 10px', borderRadius: 6, fontFamily: 'monospace' },
  modeBadge: { background: '#f4c43022', color: '#f4c430', fontSize: 11, fontWeight: 'bold', padding: '4px 10px', borderRadius: 6 },
  timeBadge: { color: '#666', fontSize: 12 },
  resultCard: {
    background: '#111128', borderRadius: 16,
    border: '1px solid #1e1e3a', padding: 24,
  },
  tableHeader: {
    display: 'flex', gap: 10, color: '#555',
    fontSize: 11, fontWeight: '600', letterSpacing: 0.5,
    marginBottom: 10, paddingBottom: 10,
    borderBottom: '1px solid #1e1e3a',
  },
  tableRow: { display: 'flex', gap: 10, alignItems: 'center', marginBottom: 10 },
  input: {
    background: '#0a0a1a', border: '1px solid #333',
    borderRadius: 8, color: '#fff', fontSize: 14,
    padding: '10px 12px', outline: 'none', boxSizing: 'border-box',
  },
  addRowBtn: {
    background: '#f4c43022', border: '1px solid #f4c43066',
    color: '#f4c430', borderRadius: 8, padding: '8px 14px',
    cursor: 'pointer', fontSize: 12, fontWeight: '600',
  },
  removeBtn: {
    background: '#ff444422', border: '1px solid #ff444444',
    color: '#ff4444', borderRadius: 8, padding: '8px 10px',
    cursor: 'pointer', fontSize: 13,
  },
  saveBtn: {
    background: '#f4c430', border: 'none', borderRadius: 12,
    color: '#000', fontWeight: 'bold', fontSize: 15,
    padding: '14px 28px', cursor: 'pointer', width: '100%',
  },
  successMsg: { color: '#00c896', fontSize: 13, fontWeight: '600', marginTop: 14, textAlign: 'center' },
};